<ef-loading-container [observables]="[]"></ef-loading-container>
<ef-process-detail [process]="process$ | async"></ef-process-detail>

<div class="card">
    <p-accordion [multiple]="true">
        <p-accordionTab [selected]="(externalIntegration$ | async)" header="Payroll Codes">
            <ng-container *ngIf="externalIntegration$ | async">
                <div class="flex align-items-center flex-wrap gap-3 mb-2">
                    <div class="flex align-items-center flex-shrink-0">
                        <p-checkbox
                            inputId="reimburseViaPayroll"
                            [binary]="true"
                            [(ngModel)]="reimburseViaPayrollChecked"
                            [ngModelOptions]="{ standalone: true }"
                            (onChange)="onReimburseViaPayrollChanged($event.checked)"
                        ></p-checkbox>
                        <label for="reimburseViaPayroll" class="ml-2">
                            Expense reports reimbursed via payroll
                        </label>
                    </div>
                    <div
                        class="flex align-items-center flex-wrap gap-2 border-left-2 border-500 pl-4"
                    >
                        <label for="expenseReimbPaycode" class="mb-0">
                            Expense Reimbursement Paycode
                        </label>
                        <p-select
                            inputId="expenseReimbPaycode"
                            [style]="{ width: '20rem' }"
                            [virtualScroll]="true"
                            itemSize="32"
                            appendTo="body"
                            [options]="expenseReimbPaycodeOptions$ | async"
                            [(ngModel)]="selectedExpenseReimbPaycode"
                            [ngModelOptions]="{ standalone: true }"
                            [disabled]="!reimburseViaPayrollChecked"
                            (onChange)="onExpenseReimbPaycodeChanged($event.value)"
                            [title]="
                                'Select a single reimbursement account as the paycode for expense reimbursements. Paycodes in this list has been identified as isolved paycodes as Reimbursement-Nontax.'
                            "
                        ></p-select>
                    </div>
                </div>
                <div class="mb-2" *ngIf="showReimburseWarning">
                    <p-message
                        severity="warn"
                        text="Turning off 'Expense reports reimbursed via payroll' will change how payroll is shown on this page. To review expenses that were sent via payroll in past pay periods, run report 202 - Supervisor Expense Report, including the Reimbursed Amount column."
                    ></p-message>
                </div>
            </ng-container>
            <ef-payroll-codes
                [items]="payrollCodes$ | async"
                [payrollCodesSelectItems]="payrollCodesSelectItems$ | async"
                [payrollCodesDescSelectItems]="payrollCodesDescSelectItems$ |async"
                [payrollCodesColumnHeaderSelectItems]="payrollCodesColumnHeaderSelectItems$ |async"
                [externalIntegration]="externalIntegration$ | async"
                (Save)="onSavePayrollCode($event)"
                (Delete)="onDeletePayrollCode($event)"
            ></ef-payroll-codes>
        </p-accordionTab>
        <p-accordionTab *ngIf="!(qboOnline$ | async)" header="Payroll Items">
            <ef-payroll-item-association
                [items]="payrollItems$ | async"
                [payrollCodes]="payrollCodesSelectItems$ | async"
                [payrollItemsSelectItems]="payrollItemsSelectItems$ | async"
                (ShowError)="onShowError($event)"
                (SaveItem)="onSavePayrollItem($event)"
            ></ef-payroll-item-association>
        </p-accordionTab>
        <p-accordionTab *ngIf="!(externalIntegration$ | async)" header="File Format">
            <div class="mb-1">
                <p-message
                    severity="info"
                    text="Re-order output fields here to save as default export file ordering."
                ></p-message>
            </div>
            <ef-third-party-payroll-file-format
                [items]="fileFormats$ | async"
                [columns]="availableColumns$ | async"
                (Save)="onSaveFileFormat($event)"
            ></ef-third-party-payroll-file-format>
        </p-accordionTab>
        <p-accordionTab [selected]="true" *ngIf="!(externalIntegration$ | async)" header="Create Export File">
            <ef-third-party-payroll-export
                [externalIntegration]="externalIntegration$ | async"
                [items]="thirdPartyPayroll$ | async"
                [payPeriodDates]="payPeriodDatesSelectItems$ | async"
                [fileFormats]="fileFormats$ | async"
                [startDate]="(userInfo$ | async).PrevPayPeriodStart"
                [endDate]="(userInfo$ | async).PrevPayPeriodEnd"
                [payrollExportFormat]="payrollExportFormat$ | async"
                (PayrollExportFormatChanged)="onPayrollExportFormatChanged($event)"
                (Export)="onExport($event)"
            ></ef-third-party-payroll-export>
        </p-accordionTab>
    </p-accordion>

    <p-dialog
        appendTo="body"
        header="Select Expense Reimbursement Paycode"
        [(visible)]="showReimbPaycodeDialog"
        [modal]="true"
        [closable]="false"
        [contentStyle]="{ 'min-width': '20rem' }"
    >
        <p class="mb-2">
            Select a reimbursement paycode to use for expense reimbursements.
        </p>
        <p-select
            [style]="{ width: '100%' }"
            [virtualScroll]="true"
            itemSize="32"
            appendTo="body"
            [options]="expenseReimbPaycodeOptions$ | async"
            [(ngModel)]="dialogExpenseReimbPaycode"
            [ngModelOptions]="{ standalone: true }"
            placeholder="(select an option)"
        ></p-select>
        <ng-template pTemplate="footer">
            <button
                pButton
                type="button"
                label="OK"
                class="p-button-primary"
                [disabled]="!dialogExpenseReimbPaycode"
                (click)="onReimbPaycodeDialogOk()"
            ></button>
        </ng-template>
    </p-dialog>
</div>

